import Reflection from '../reflection.js';

/**
 * Create the action
 */

const { thunk, request, success, error } = Reflection.update((data, fetch) =>
  fetch.patch(`/reflections/${data.id}`, data)
);

/**
 * Export the components
 */

export { thunk as default };
export { request, success, error };
